export const Identifiers = {
  isAppliance: {
    // eslint-disable-next-line id-length
    read(_, _ref) {
      let {
        readField
      } = _ref;
      const productType = readField('productType');
      return !!((productType === null || productType === void 0 ? void 0 : productType.toUpperCase()) === 'MAJOR_APPLIANCE');
    }
  }
};
//# sourceMappingURL=Identifiers.js.map